import React from 'react';

/** Lightweight static backdrop when WebGL is disabled (mobile / reduced motion). */
export const MobileBackdrop: React.FC = () => (
  <div
    className="fixed inset-0 z-[-1] pointer-events-none bg-[#020203]"
    aria-hidden
  >
    <div className="absolute inset-0 bg-gradient-to-b from-indigo-950/40 via-transparent to-[#020203]" />
    <div className="absolute inset-0 opacity-[0.15] bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(99,102,241,0.25),transparent)]" />
  </div>
);
